/**
 * Canonical room / match id normalization (join input / legacy ids).
 * New sessions use {@link generateSessionRoomId} — display names are not ids.
 */
export function normalizeMatchRoomCode(raw) {
  if (raw == null || typeof raw !== "string") return "";
  return raw.trim().toLowerCase().replace(/\s+/g, "-");
}

const SESSION_ID_CHARS = "abcdefghijklmnopqrstuvwxyz23456789";

/** Default length for new session room codes (offline-friendly). */
export const SESSION_ROOM_CODE_LENGTH = 7;

/** Uppercase display for room codes (join still accepts any case). */
export function formatSessionRoomCodeDisplay(code) {
  if (code == null || typeof code !== "string") return "";
  return code.trim().toUpperCase();
}

/** @returns {string} Lowercase room code for `matches/{id}` (not derived from display name). */
export function generateSessionRoomId(length = SESSION_ROOM_CODE_LENGTH) {
  const size = Math.min(Math.max(length, 6), 16);
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    const bytes = new Uint8Array(size);
    crypto.getRandomValues(bytes);
    let out = "";
    for (let i = 0; i < size; i += 1) {
      out += SESSION_ID_CHARS[bytes[i] % SESSION_ID_CHARS.length];
    }
    return out;
  }
  let out = "";
  for (let i = 0; i < size; i += 1) {
    out += SESSION_ID_CHARS[Math.floor(Math.random() * SESSION_ID_CHARS.length)];
  }
  return out;
}
